import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 480 +'px',
      label: '',
      accountBalance: '',
      content: ''
    }
  },
  computed: {
    ...mapState('myStoredValueModule', ['myStoredValue','storedValueCardDefinitionList']),
    myStoredValueInfo () {
      return this.myStoredValue
    },
    storedValueCardDefinitionListInfo () {
      return this.storedValueCardDefinitionList
    }
  },
  methods: {
    ...mapActions('myStoredValueModule', ['getMemberStoredValue','getMemberStoredValueCardDefinitionId']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    generateUrl (content) {
      this.centerDialogVisible = true
      this.qrCode = `//${location.host}/api/qr/generate?content=${content}&X-Authorization=${localStorage.getItem('token')}`
    },
    getMemberStoredValueInfo (type) {
      if (type) {
        this.type = type
      }
      let pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageSort: this.pageSort,
        pageOrder: this.pageOrder,
      }
      if (this.type !== '0') {
        pageData.expenditureOrIncome = type * 1
      }
      this.getMemberStoredValue(pageData)
    },
    load () {
      this.pageSize += 10
      this.getMemberStoredValueInfo(this.type)
    },
    openStoredValueDetails () {
      this.$router.push({
        path: RoutePathConstants.MY_STORED_VALUE_DETAILS
      })
    },
    openStoredValueCardCord () {
      this.$router.push({
        path: RoutePathConstants.MY_STORED_VALUE_DETAILS
      })
    }
  },
  mounted () {
    // this.getMemberStoredValueInfo()
    this.label = this.$route.query.label
    this.accountBalance = this.$route.query.accountBalance
    this.content = `//${location.host}/api/qr/generate?content=${this.$route.query.content}&X-Authorization=${localStorage.getItem('token')}`
    // this.getMemberStoredValueCardDefinitionId(carList)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-stored-value/views/my-stored-value-code.js